export default "__VITE_ASSET__d47360dd__"